const humanNames = {
  UCB: 'Berkeley',
  UCLA: 'Los Angeles',
  UCSD: 'San Diego',
  UCD: 'Davis',
  UCSF: 'San Francisco',
  UCSB: 'Santa Barbara',
  UCI: 'Irvine',
  UCSC: 'Santa Cruz',
  UCR: 'Riverside',
  UCOP: 'Office of the President',
  UCM: 'Merced',

};

export default humanNames;
